<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form">
      <div class="del-block" v-if="info">
        <div class="btn btn-danger" data-toggle="modal" data-target="#delModal">刪除門市綁定</div>
      </div>
      <br  v-if="info" />
      <br />
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          名稱
        </span>
          <input class="form-control" placeholder="" type="text" v-model="content.name" maxlength="20">
        </div>
        <br />
      </div>
      <div v-if="!info">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>品牌
        </span>
          <multiselect v-model="select.bindingBrandList" tag-placeholder="品牌綁定"
                       placeholder="選擇品牌" label="label" track-by="value" :options="brandBrief"
                       :multiple="false" :allow-empty="false"></multiselect>
          <!--<v-select v-model="content.bindingBrandList" :options="brandBrief" class="h-38"></v-select>-->
        </div>
        <br />
      </div>
      <div v-if="!info">
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>店家
        </span>
          <multiselect v-model="select.bindingStoreList" tag-placeholder="店家綁定"
                       placeholder="選擇店家" label="label" track-by="value" :options="storeBrief"
                       :multiple="false" :allow-empty="false"></multiselect>
          <!--<v-select v-model="content.bindingStoreList" :options="storeBrief" class="h-38"></v-select>-->
        </div>
        <br />
      </div>
      <div  v-if="info">
        <div class="input-group">
        <span class="input-group-addon">
          啟用
        </span>
          <div class="form-group">
            <select class="form-control" v-model="content.is_enabled">
              <option :value="1">啟用</option>
              <option :value="0">不啟用</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <!-- up end -->
      <!-- /.box-body -->
    </div>
    <div class="box-footer text-center">
      <router-link :to="'/printerInfo/' + $route.params.printer_id">
        <button class="btn btn-default">
          取消
        </button>
      </router-link>
      <button class="btn btn-success" v-if="!info" @click="crPrinterStore">
        新增
      </button>
      <button class="btn btn-success" v-if="info" @click="upPrinterStore">
        修改
      </button>
    </div>
    <br />
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import matcherModal from '../../../elements/Modal.vue'
export default {
  props: {
    'info': {
      type: Object
    },
    'current': {
      type: Object
    },
    'brandList': {
      type: Array
    },
    'storeList': {
      type: Array
    },
    'posList': {
      type: Array
    }
  },
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      phone: '',
      radioRoleType: 'admin',
      delOption: {
        id: 'delModal',
        title: '刪除店家綁定',
        body: '確定刪除?<br>刪除此店家綁定！',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delBinding'
          }
        ]
      },
      show: {
        delBtn: false
      },
      select: {
        bindingBrandList: {},
        bindingStoreList: {},
        bindingPosList: {}
      },
      content: {
        name: '',
        is_enabled: 0,
        bindingBrandList: [],
        bindingStoreList: []
      },
      birth: {
        time: ''
      },
      brandName: '',
      brandType: '',
      brandBrief: [],
      storeBrief: [],
      brandDefault: 0
    }
  },
  methods: {
    init () {
      if (!this.info) {
        this.getBrandBrief()
        this.getPosBrief()
      }
    },
    trigger (event) {
      if (event === 'delBinding') {
        this.delBinding()
      }
    },
    checkPrinterStore (type) {
      var msg = ''
      if (!this.select.bindingStoreList.value && !this.info) {
        msg = '請選擇綁定店家'
      }
      this.getToast(msg, type)
    },
    getToast (msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.crPrinterStore()
        else if (type === 'up') this.upPointerStore()
      }
    },
    crPrinterStore () {
      var self = this
      var url = '/printer/storePrinter'
      var info = this.content
      var data = {
        printer_id: this.$route.params.printer_id,
        store_id: this.select.bindingStoreList.value
      }
      if (this.content.name) data['name'] = info.name
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/printerInfo/' + self.$route.params.printer_id)
        }
      })
    },
    upPrinterStore () {
      var self = this
      var url = '/printer/storePrinter/' + this.$route.params.binding_id
      var info = this.content
      var data = {
        is_enabled: info.is_enabled
      }
      if (this.content.name) data['name'] = info.name
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/printerInfo/' + self.$route.params.printer_id)
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            if (i === 0) {
              if (!self.storeList) self.brandDefault = obj.value
              else {
                if (!self.storeList.length) self.brandDefault = obj.value
                else self.brandDefault = self.storeList[0].brand_id
              }
            }
          }
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | PrinterStoreFormTemp')
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    delBinding () {
      var self = this
      var url = '/printer/storePrinter/' + this.$route.params.binding_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/printerInfo/' + self.$route.params.printer_id)
        }
      })
    },
    getPosBrief () {
      this.posBrief = []
      var self = this
      var url = '/pos/vendorBriefList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var pList = response.data.list
          for (let i = 0; i < pList.length; i++) {
            let obj = {label: pList[i].name, value: pList[i].po_vendor_id}
            self.posBrief.push(obj)
          }
        }
      })
    }
  },
  created () {
    this.init()
  },
  watch: {
    'select.bindingBrandList' () {
      this.getStoreBrief(this.select.bindingBrandList.value)
      this.select.bindingStoreList = {}
      this.content.bindingBrandList = [this.select.bindingBrandList]
    },
    'select.bindingStoreList' () {
      this.content.bindingStoreList = [this.select.bindingStoreList]
    },
    'select.bindingPosList' () {
      this.content.bindingPosList = [this.select.bindingPosList]
    },
    info () {
      /* update */
      const info = this.info
      const content = this.content
      content.name = info.binding_name
      content.is_enabled = info.binding_is_enabled
    },
    brandDefault () {
      this.storeBrief = []
      this.bindingStoreList = []
      this.content.bindingStoreList = []
      this.getStoreBrief(this.brandDefault)
    },
    brandBrief () {
      var contentBList = []
      var bList = this.brandList
      if (bList) {
        for (var i = 0; i < bList.length; i++) {
          this.brandBrief.filter(function (elem, index, obj) {
            if (elem.value === bList[i]) {
              contentBList.push(elem)
            }
          })
        }
        this.content.bindingBrandList = contentBList
        this.select.bindingBrandList = contentBList
      }
    },
    storeBrief () {
      var contentSList = []
      if (this.storeList) {
        if (this.storeList.length) {
          var sList = this.storeList[0].binding_store_list
          if (sList) {
            for (var i = 0; i < sList.length; i++) {
              this.storeBrief.filter(function (elem, index, obj) {
                if (elem.value === sList[i]) {
                  contentSList.push(elem)
                }
              })
            }
            this.content.bindingStoreList = contentSList
            this.select.bindingStoreList = contentSList[0]
          }
        }
      }
    },
    posBrief () {
      var contentPList = []
      var pList = this.posList
      if (pList) {
        for (var i = 0; i < pList.length; i++) {
          this.posBrief.filter(function (elem, index, obj) {
            if (elem.value === pList[i]) {
              contentPList.push(elem)
            }
          })
        }
        this.content.bindingPosList = contentPList
        this.select.bindingPosList = contentPList
      }
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    bindStore () {
      var contentSList = []
      var sList = this.storeList
      if (sList) {
        for (var i = 0; i < sList.length; i++) {
          this.storeBrief.filter(function (elem, index, obj) {
            if (elem.value === sList[i]) {
              contentSList.push(elem)
            }
          })
        }
        return contentSList
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PrinterStoreFormTemp.vue?206172ec